import "./class.moduleRenamed.css";

export const label = "class-module__label___y0RdW";
export const secondLabel = "class-module__secondLabel___BUw3I";
export const oneLine = "class-module__oneLine___3fzD7";

export default {
  label: "class-module__label___y0RdW",
  secondLabel: "class-module__secondLabel___BUw3I",
  oneLine: "class-module__oneLine___3fzD7",
};